// ============================================================================
// CORPORATE ENDPOINTS
// ============================================================================
// API endpoint definitions for Corporate module

import { buildEndpoint } from './base.endpoints';
import type { ID } from '../types/common.types';

const BASE_PATH = '/Corporate';

export const corporateEndpoints = {
  /** GET /Corporate — list all (paginated) */
  list: () => buildEndpoint(BASE_PATH),

  /** GET /Corporate/{id} — get by ID */
  getById: (id: ID) => buildEndpoint(`${BASE_PATH}/${id}`),

  /** GET /Corporate/code/{code} — get by code */
  getByCode: (code: string) => buildEndpoint(`${BASE_PATH}/code/${code}`),

  /** POST /Corporate — create */
  create: () => buildEndpoint(BASE_PATH),

  /** PUT /Corporate/{id} — update */
  update: (id: ID) => buildEndpoint(`${BASE_PATH}/${id}`),

  /** DELETE /Corporate/{id} — delete */
  delete: (id: ID) => buildEndpoint(`${BASE_PATH}/${id}`),

  /** GET /Corporate/validate/code/{code} — validate code uniqueness */
  validateCode: (code: string) => buildEndpoint(`${BASE_PATH}/validate/code/${code}`),
};

export default corporateEndpoints;
